import { Badge, BadgeProps, Flex } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { useScreenSizes } from 'src/utilities/useScreenSizes';

interface CreditAvailabilityBadgeProps {
  creditProgressStatusContent: BadgeProps;
}

export function CreditAvailabilityBadge({
  creditProgressStatusContent,
}: CreditAvailabilityBadgeProps): JSX.Element {
  const { isPhone } = useScreenSizes();

  return (
    <Flex justifyContent={isPhone ? 'flex-start' : 'flex-end'}>
      <Badge radius="squared" {...creditProgressStatusContent} />
    </Flex>
  );
}
